import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const SrcSkelton = (props: IContentLoaderProps) => {
  const { className = '', ...restProps } = props;
  return (
    <div className={`flex flex-col ${className}`}>
      <ContentLoader speed={2} width="20%" viewBox="0 0 82 24" backgroundColor="#ECEEF3" foregroundColor="#DBDDE2" {...restProps}>
        <circle cx="12" cy="12" r="12" />
        <rect x="32" y="7" rx="2" ry="2" width="50" height="10" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        viewBox="0 0 424 70"
        backgroundColor="#ECEEF3"
        foregroundColor="#DBDDE2"
        className={`bg-#F4F6F9CC rounded-4 mt-2.5 ${className}`}
      >
        <rect x="16" y="16" rx="3" ry="3" width="392" height="6" />
        <rect x="16" y="32" rx="3" ry="3" width="392" height="6" />
        <rect x="16" y="48" rx="3" ry="3" width="200" height="6" />
      </ContentLoader>
    </div>
  );
};

export default SrcSkelton;
